import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { InventoryConsumption } from "../../../Context/InventoryConsumption";

export const BuyAddonPlan = () => {
  const { t: locale } = useTranslation();
  const navigate = useNavigate();
  const {
    showBuyAddonPlan,
    inventoryType,
    upgradeAvailableFor,
    setShowBuyAddonPlan,
    buttonSelection,
    setButtonSelection,
    redirectTo,
    setRedirectTo,
  } = useContext(InventoryConsumption);

  const resetModalRedirectState = () => {
    setShowBuyAddonPlan(false);
    setRedirectTo(false);
  };

  const buyAddonPlan = (value) => {
    setButtonSelection(value);
    setRedirectTo(true);
    setShowBuyAddonPlan(false);
    navigate("/settings/accounts-and-billing", {
      state: {
        redirectPageParams: {
          activeTab: "accounts-and-billing",
          subTab: value,
        },
      },
    });
  };

  const hideModal = () => {
    resetModalRedirectState();
  };

  return (
    <Modal show={showBuyAddonPlan} onHide={hideModal} style={{ zIndex: 99999 }}>
      <Modal.Header closeButton>
        <Modal.Title>{locale("Inventory Consumption")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {locale(
          "You have reached the limit for {inventoryType}. You can choose one of the following options",
          {
            inventoryType:
              inventoryType === "document"
                ? "space"
                : inventoryType
                ? inventoryType.replaceAll("_", " ")
                : "",
          }
        )}
        .
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={hideModal}>
          {locale("Do Later")}
        </Button>
        {upgradeAvailableFor && upgradeAvailableFor === "addon" && (
          <Button variant="success" onClick={() => buyAddonPlan("addons")}>
            {locale("Buy Addon")}
          </Button>
        )}
        <Button variant="success" onClick={() => buyAddonPlan("plan")}>
          {locale("Upgrade Plan")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
